import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './redux/store';
import { Auth0Provider } from '@auth0/auth0-react';
import './config';

ReactDOM.render(
  <Provider store={store}>
    <Auth0Provider
      {...{
        domain: 'asset-database.eu.auth0.com',
        clientId: 'rr2kpYluPTCnQFezuw2Dco8xQxiYjNfW',
        redirectUri: window.location.origin,
        audience: localStorage.getItem('acc360.audience'),
      }}
    >
      <App />
    </Auth0Provider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
